/* eslint-disable @typescript-eslint/no-non-null-assertion */
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { IconButton, Tooltip, Typography } from "@mui/material";
import React from "react";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";

import { Label, RadioButtonLabel, RadioFieldContent } from "../home/Home.sc";

interface Props {
    label: NonNullable<React.ReactNode>;
    tooltip: NonNullable<React.ReactNode>;
    name: string;
    disabled?: boolean;
}

export const YesNoRadio = ({ label, tooltip, name, disabled }: Props) => {
    const { t } = useTranslation();

    return (
        <>
            <Label>
                <Typography style={{ marginRight: 8 }}>{label}</Typography>
                <Tooltip disableFocusListener title={tooltip} enterTouchDelay={0} leaveTouchDelay={5000} sx={{ m: 1 }} placement="top" arrow>
                    <IconButton style={{ padding: 0, margin: 0 }}>
                        <InfoOutlinedIcon />
                    </IconButton>
                </Tooltip>
            </Label>
            <RadioFieldContent>
                <RadioButtonLabel>
                    <Field name={name} component="input" type="radio" value="yes" disabled={disabled} />
                    {t("yes")}
                </RadioButtonLabel>
                <RadioButtonLabel>
                    <Field name={name} component="input" type="radio" value="no" disabled={disabled} />
                    {t("no")}
                </RadioButtonLabel>
            </RadioFieldContent>
        </>
    );
};
